import { useEffect, useState } from "react";
import SideMenu from "../components/SideMenu";
import { useParams } from "react-router-dom";
import { getReports } from "services/apf-api.service";
import { useAuth } from "providers/auth.provider";

export default function Reports() {
  const { siteId } = useParams<{ siteId: string }>();
  const { idToken } = useAuth();

  const [loading, setLoading] = useState(false);
  const [reports, setReports] = useState<any>(null);

  useEffect(() => {
    setLoading(true);

    const fetchReports = async () => {
      if (typeof siteId === "string") {
        setReports(await getReports(siteId, idtoken));
      }
      setLoading(false);
    };

    fetchReports();
  }, [siteId]);

  return (
    <div className="grid min-h-screen grid-cols-1 md:grid-cols-[240px_1fr]">
      <SideMenu siteId={siteId} />
      <main className="p-6">
        <div className="mb-6 items-center">
          <h1 className="text-2xl font-semibold tracking-left">Reports</h1>
          <p className="text-sm text-muted-foreground">
            Soon you will be able to review in-depth monthly reports for your
            website. Check back soon!
          </p>
          <p className="text-sm text-muted-foreground">
            Reports created: {reports?.length}
          </p>
        </div>
      </main>
    </div>
  );
}
